export default __webpack_public_path__ + "static/media/settingsActive.c37b1253.svg";